import { createFileRoute } from "@tanstack/react-router";
import { CircleEuroIcon } from "lucide-react";

import { CreateClaimWizard } from "@/features/create-claim/components/create-claim-wizard";

export const Route = createFileRoute("/_authed/_dashboard/claims/create")({
  component: CreateClaimPage,
});

/** Port of pages/CreateClaim.vue — manual claim creation wizard. */
function CreateClaimPage() {
  return (
    <div className="w-full grow bg-zinc-50 px-4 py-14 sm:px-6 lg:px-12">
      <div className="w-full pb-8 text-left sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="flex items-center gap-2 text-lg font-semibold leading-6 text-gray-900">
            <CircleEuroIcon className="h-5 w-5 flex-none text-stone-400" aria-hidden="true" />
            Demande d'indemnisation
          </h1>
          <p className="mt-2 text-sm leading-6 text-gray-700">
            Faire une demande d'indemnisation manuelle auprès d'Upclaim.
          </p>
        </div>
      </div>
      <div className="rounded-lg border bg-white px-12 pt-12 shadow-sm">
        <CreateClaimWizard />
      </div>
    </div>
  );
}
